export default "__VITE_ASSET__D9dGe8ki__"